import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3'
import { getSignedUrl } from '@aws-sdk/s3-request-presigner'
import { saveAs } from 'file-saver'
import * as _ from 'lodash'
import { getJWTPayload, FILE_TYPES } from '.'

const { VITE_REACT_APP_RESULT_BUCKET, VITE_REACT_APP_DOCS_BUCKET } = import.meta.env
const DOMAIN_NAME = 'tecd'
const cb = window.cb

export interface FileMetadataType {
  type: FILE_TYPES
  originalFileName: string
  di_code: string
  jobId: string
  clientType?: string
}

const getS3Metadata = (metadata: FileMetadataType) => {
  const bucket = getBucket(metadata.type)
  const { key, outputFileName } = getKey(metadata)

  return {
    bucket,
    key,
    outputFileName,
  }
}

const getBucket = (type: FILE_TYPES) => {
  let bucketType
  switch (type) {
    case FILE_TYPES.DOC:
      bucketType = VITE_REACT_APP_DOCS_BUCKET
      break
    // As of now, AGG/JOB/QC files all exist in the REACT_APP_RESULT_BUCKET
    default:
      bucketType = VITE_REACT_APP_RESULT_BUCKET
      break
  }
  return bucketType
}

const getKey = (metadata: FileMetadataType) => {
  const { type, originalFileName, di_code, jobId, clientType } = metadata
  let key
  let outputFileName
  switch (type) {
    case FILE_TYPES.AGG:
      outputFileName = `${di_code}_full.csv`
      key = `external/agg/${di_code}_full.part_00000`
      break
    case FILE_TYPES.JOB:
      outputFileName = `${di_code}_${jobId}_${originalFileName}.csv`
      key = `external/job/${di_code}_${jobId}_${originalFileName}.part_00000`
      break
    case FILE_TYPES.QC:
      outputFileName = `${originalFileName}_qc_check_${clientType}.csv`
      key = `${clientType}/qc/${di_code}_${jobId}_${originalFileName}`
      break
    default:
      outputFileName = originalFileName
      key = originalFileName
      break
  }
  return {
    key,
    outputFileName,
  }
}

interface downloadAnyFileFromS3Props {
  metadata: FileMetadataType
  setLoading?: Function
  onFileDoesNotExist?: Function
  callback?: () => void
}

export const downloadAnyFileFromS3 = async (props: downloadAnyFileFromS3Props) => {
  const { metadata, setLoading, onFileDoesNotExist, callback } = props
  const { bucket, key, outputFileName } = getS3Metadata(metadata)
  const jwtPayload = getJWTPayload()
  const awsCredentials = cb.core.iam.getTempAWSCreds(DOMAIN_NAME)

  // Check if the credentials are there and have not expired
  if (awsCredentials && jwtPayload) {
    const s3Client = new S3Client({ region: 'us-east-1', credentials: awsCredentials })

    // Get a signed url to the file in S3. Expire in 60 seconds.
    const params = {
      Bucket: bucket,
      Key: key,
    }
    const command = new GetObjectCommand(params)
    const fileUrl = await getSignedUrl(s3Client, command, { expiresIn: 60 })

    return fetch(fileUrl)
      .then((res) => {
        if (res.status === 403 && onFileDoesNotExist) {
          onFileDoesNotExist && onFileDoesNotExist()
          setLoading && setTimeout(() => setLoading(false), 1000)
        } else {
          return res.blob()
        }
      })
      .then((blob) => {
        saveAs(blob, outputFileName)
        setLoading && setLoading(false)
      })
      .then(() => {
        callback && callback()
      })
  }
}
